
<div class="stage-status-wrapper" :type="type">
	<div class="stage-status-icon">
		<Icon :name="iconName" size="small" :type="iconType" />
	</div>
	<div class="stage-status">
		{{ status }}
	</div>
</div>
